/** API */
//export const apiUrl = 'http://localhost:3030/'; //https://nebulea.eu/api/ http://localhost:3030/
export const apiUrl = "https://nebulea.eu/api/"; //https://nebulea.eu/api/ http://localhost:3030/

/** MAPBOX */
export const mapboxAccesToken =
  "pk.eyJ1IjoiYWxleGFuZHJlbmVidWxlYSIsImEiOiJjanc5NWJvd3MwY3ZxNDNteDBvdWQ1eTlzIn0.3_cS4JewhuJENlZjcWk33Q";
export const mapboxApiUrl = "https://api.mapbox.com/";

/** STRIPE */
export const stripeApiKey = "pk_live_pGiWoi4XuIRGVw8doWGwf2Ch"; //pk_test_eMXby7bWV0cf2KugGRwGaCRX pk_live_pGiWoi4XuIRGVw8doWGwf2Ch

export const zoomOnePoint = 14;
export const zoomTwoPoint = 10;

export const Yellow = "rgb(252, 235, 38)";
export const Blue = "#101526";
export const White = "rgb(255,255,255)";
export const Black = "#0B060D";
export const LightGrey = "#878488";
export const LightBlack = "#2D3140";
export const Red = "#dc3545";
export const Green = "#28a745";

export const interval = 5000;

/** Driver Group IDs */
export const GS_TAXI_GEOFFRAY_DG_ID = "636a32d7611f64dcf3896252";
export const FLOTTE_DEMO_DG_ID = "5d249a47274bb33b61e54cbe";
export const LABDOUN_EST_DG_ID = "63e2d19c40af4b33f38034e2";
export const BIMBOUM_DG_ID = "63737312bc984006f1148cbc";
export const VTC_DS_TOUR_DG_ID = "68f509d7acf6115c16d8bb4b";
export const IVOCAB_DG_ID = "686bdab1d010ae05c6879e3b";
export const ISIS_LIMOUSINE_DG_ID = "67fc398678e6ef46bbaffd21";
export const GO_CHARLIE_DG_ID = "667fee2095ae6c07de1d1deb";
export const MY_VTC_RENNES_DG_ID = "67bc61c49103cd17e0c92416";
export const ANC_DG_ID = "667185f6739d9f7aecfdfdc0";
export const SAS_WHEELMAN_DG_ID = "65d9aaf4f655706c245f6049";
export const MY_CHAUFFEUR_DG_ID = "6217758a659fd472a6bbd7ec";
export const ELEC_DRIVE_DG_ID = "61750c1a73aabb77e3ae8fd7";
export const GLOBAL_SPHERE_DG_ID = "635437e657f3da0bad48dacd";
export const ELEXI_TRAVEL_EVENT_DG_ID = "602541c92c742139c38d61b1";
export const LWL_DRIVE_DG_ID = "63daf8ff5243c4458f634253";
export const EJA_TRANSPORT_DG_ID = "64196a172816a34220d1020f";
export const TAXI_FRED_DG_ID = "63e26e2440af4b33f380334a";
export const LA_CENTRALE_DES_CHAUFFEURS_DG_ID = "63d2b04a261f9a1e5076687c";
export const VTC_ANTILLES_DG_ID = "6432edbb36729a71e8b33942";
export const LES_CHAUFFEURS_DE_L_ERDRE_DG_ID = "651ae7418f87d906112348bc";
export const YOU_CALL_YOU_GO_DG_ID = "6540e0d89bfd116709a6c771";
export const TESLASTARS_DG_ID = "648c71c23fc7c221026d2245";
export const ELEXI_BORDEAUX_DG_ID = "5d682842380f2c3888ae7d93";
export const VTC_BORDEAUX_DG_ID = "6554f4a63142f06f598fb55a";
export const R_DRIVE_DG_ID = "668542dcd4728771855481ae";
export const ETIENNE_DEROUINEAU_DG_ID = "66854c5cd472877185548200";
export const RYV_DG_ID = "66733dea0b1c46139a65ce0b";
export const UN_CHAUFFEUR_POUR_VOUS_DG_ID = "634bf36e1efcfa3530d63a16";
export const WESLEY_VOUS_TRANSPORTE_DG_ID = "64fad6e7ef80cf3cf351d243";
export const ONYX_DG_ID = "640c8f1408405a20eeadaf48";
export const TAXI_CHAMONIX_VALLEY_DG_ID = "63e0e8036675f44c171b11cd";
export const SAFEDRIVE_SERVICES_DG_ID = "66b4879627c6c3766b51856d";
export const SAFEDRIVE_NAVETTES_DG_ID = "66b4c74927c6c3766b5189b5";
export const FRANCE_TAXI_MOBILITE_DG_ID = "68de4ede00efa10bb0dc5181";
export const PREMIER_FRANCE_TAXI_MOBILITE_DG_ID = "62ff607dd9b46a73b6e43354";
export const NORMANDIE_TAXIS_DG_ID = "645017afbb82581e283c3a31";
export const TAXI_DILBEEK_DG_ID = "60217634eef2fc1af516d087";

/** Liste des DGs autorisés à utiliser le mode inscription / connexion sur nebulea.eu/dg/:id */
export const BookingPlatformAllowed = [GS_TAXI_GEOFFRAY_DG_ID, FLOTTE_DEMO_DG_ID, LABDOUN_EST_DG_ID, BIMBOUM_DG_ID, VTC_DS_TOUR_DG_ID];

/** Liste des DGs autorisés à utiliser le mode Rapports d'activités et autofactures */
export const ExpertsAllowed = [IVOCAB_DG_ID, ISIS_LIMOUSINE_DG_ID, GO_CHARLIE_DG_ID, MY_VTC_RENNES_DG_ID, ANC_DG_ID, SAS_WHEELMAN_DG_ID, MY_CHAUFFEUR_DG_ID, ELEC_DRIVE_DG_ID, GLOBAL_SPHERE_DG_ID, FLOTTE_DEMO_DG_ID, ELEXI_TRAVEL_EVENT_DG_ID, LWL_DRIVE_DG_ID, EJA_TRANSPORT_DG_ID, TAXI_FRED_DG_ID, LA_CENTRALE_DES_CHAUFFEURS_DG_ID];

/** Prépaiement obligatoire nebulea.eu/dg/:id */
export const PrepaymentRequired = [GS_TAXI_GEOFFRAY_DG_ID, FLOTTE_DEMO_DG_ID, LABDOUN_EST_DG_ID, ELEC_DRIVE_DG_ID, TAXI_FRED_DG_ID, VTC_ANTILLES_DG_ID];
